module.exports = __webpack_public_path__ + "img/camila.8f578137.png";